module.exports = __webpack_public_path__ + "img/trash.5dda1f39.svg";